"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BranchGraphColumn_1 = require("./type/BranchGraphColumn");
exports.BranchGraphColumn = BranchGraphColumn_1.BranchGraphColumn;
const ButtonColumn_1 = require("./type/ButtonColumn");
exports.ButtonColumn = ButtonColumn_1.ButtonColumn;
const CheckColumn_1 = require("./type/CheckColumn");
exports.CheckColumn = CheckColumn_1.CheckColumn;
const Column_1 = require("./type/Column");
exports.Column = Column_1.Column;
const IconColumn_1 = require("./type/IconColumn");
exports.IconColumn = IconColumn_1.IconColumn;
const ImageColumn_1 = require("./type/ImageColumn");
exports.ImageColumn = ImageColumn_1.ImageColumn;
const MenuColumn_1 = require("./type/MenuColumn");
exports.MenuColumn = MenuColumn_1.MenuColumn;
const MultilineTextColumn_1 = require("./type/MultilineTextColumn");
exports.MultilineTextColumn = MultilineTextColumn_1.MultilineTextColumn;
const NumberColumn_1 = require("./type/NumberColumn");
exports.NumberColumn = NumberColumn_1.NumberColumn;
const PercentCompleteBarColumn_1 = require("./type/PercentCompleteBarColumn");
exports.PercentCompleteBarColumn = PercentCompleteBarColumn_1.PercentCompleteBarColumn;
const TYPES = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    DEFAULT: new Column_1.Column(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    NUMBER: new NumberColumn_1.NumberColumn(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    CHECK: new CheckColumn_1.CheckColumn(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    BUTTON: new ButtonColumn_1.ButtonColumn(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    IMAGE: new ImageColumn_1.ImageColumn(),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    MULTILINETEXT: new MultilineTextColumn_1.MultilineTextColumn(),
};
function of(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
columnType
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
    if (!columnType) {
        return TYPES.DEFAULT;
    }
    else if (typeof columnType === "string") {
        const key = columnType.toUpperCase();
        return TYPES[key] || of(null);
    }
    else {
        return columnType;
    }
}
exports.of = of;
